import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { mediaMax } from "../../helpers/MediaQueries";
import iconClose from '../../images/icon-close.svg'
import { StaticImage } from "gatsby-plugin-image";
// import { Link } from "gatsby";

const BannerWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 100%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  visibility: hidden;
  opacity: 0;
  transition: opacity .75s ease-out;
  z-index: 888;
  &.active {
    bottom: 0;
    visibility: visible;
    opacity: 1;
  }
`;

const Banner = styled.div`
  max-width: 646px;
  padding: 0 24px 36px 24px;
  text-align: center;
  font-family: Optima;
  font-size: 19px;
  color: #000;
  font-weight: 400;
  line-height: 1.25;
  background: #ffffff;
  position: relative;
  z-index: 2;
  h3 {
    margin: 0 0 29px 0;
    font-size: 38px;
    color: #9EA69C;
    line-height: 1;
    font-weight: 400;
    letter-spacing: 1.9px;
    text-transform: uppercase;
  }
  p {
    max-width: 510px;
    margin: 0 auto 25px auto;
    a {
      color: inherit;
    }
  }
  ${mediaMax.phoneXL`
    padding: 0 22px 20px 22px;
    text-align: left;
    font-size: 15px;
    h3 {
      margin: 0 0 15px 0;
      font-size: 24px;
      line-height: 1.25;
      letter-spacing: 1.2px;
    }
    p {
      margin: 0 0 17px 0;
    }
  `}
`;

const ButtonClose = styled.div`
  position: absolute;
  top: 28px;
  right: 20px;
  z-index: 2;
  cursor: pointer;
  ${mediaMax.phoneXL`
    top: 18px;
    right: 16px;
  `}
`;

const ImgWrapper = styled.div`
  margin: 0 -24px 32px -24px;
  ${mediaMax.phoneXL`
    margin: 0 -22px 20px -22px;
  `}
`;

const Button = styled.a`
  display: inline-block;
  vertical-align: top;
  padding: 10px 10px 9px 13px;
  text-decoration: none;
  font-family: Optima;
  font-size: 17px;
  color: #000;
  letter-spacing: 2.72px;
  text-transform: uppercase;
  border-radius: 5px;
  background: #9EA69C;
  transition: background .3s ease-out;
  text-box-trim: trim-both;
  text-box-edge: cap alphabetic;
  &:hover {
    background: #88a585;
  }
  ${mediaMax.phoneXL`
    padding: 10px 10px 9px 13px;
    font-size: 16px;
    letter-spacing: 2px;
  `}
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right:0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1;
`;


const BannerModal = (location) => {
  const bannerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false)
  const pathNameWithoutSlashes = location.location.pathname.replace(/\//g, '')

  useEffect(() => {
    const firstLoadPopup = localStorage.getItem("firstLoadPopup");
    if (!firstLoadPopup && pathNameWithoutSlashes !== 'contact') {
      const handleScroll = () => {
        const scrollY = window.scrollY;
        const triggerOffset = 200;
        if (scrollY > triggerOffset) {
          setTimeout(() => setIsOpen(true), 100)
          setTimeout(() => bannerRef?.current?.classList.add('active'), 600)
          window.removeEventListener('scroll', handleScroll);
        }
      };

      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [])

  const closeModal = () => {
    bannerRef?.current?.classList.remove('active')
    setTimeout(() => setIsOpen(false), 750)
    localStorage.setItem("firstLoadPopup", "true");
  }

  useEffect(() => {
    localStorage.removeItem("firstLoadPopup");
  }, []);

  return (
    <>
      {isOpen && (
        <BannerWrapper ref={bannerRef}>
          <Banner>
            <ButtonClose onClick={closeModal}><img src={iconClose} alt="icon close X" /></ButtonClose>
            <ImgWrapper><StaticImage src="../../../static/popup_image.jpg" alt="" /></ImgWrapper>
            <h3>Parkhouse Residences<br/> is Sold Out</h3>
            <p>
              We’re pleased to announce that all residences at Parkhouse have sold. Thank you to our homeowners, partners, and community for being part of Parkhouse.<br/><br/>
              To explore other communities by Shopoff Realty Investments, visit <a href="https://www.shopoff.com/" target="_blank" rel="noreferrer">shopoff.com</a>.
            </p>
            <Button href="https://www.shopoff.com/" target="_blank" rel="noreferrer">Explore More Communities</Button>
          </Banner>
          <Overlay onClick={closeModal} />
        </BannerWrapper>
      )}
    </>
  )
}

export default BannerModal